import { FormControl, Validators } from '@angular/forms';
import { Tab } from '../tab';

export class TabForm {
    id = new FormControl();
    Name = new FormControl();
    RecordKey = new FormControl();
    Exclude = new FormControl();

    constructor(tab: Tab) {

        this.id.setValue(tab.id);
        this.Name.setValue(tab.name);
        this.RecordKey.setValue(tab.RecordKey);
        this.Exclude.setValue(tab.Exclude);
        
        // this.Name.setValidators([Validators.required]);
    }
}